import { TZDate } from "@date-fns/tz";
import { addDays } from "date-fns";

import type { BuildRelativeParams } from "$src/core/models/epg";
import buildRelativeDateRange from "$src/core/utils/date/build-relative-date-range";
import getDeviceTimeZone from "$src/core/utils/date/get-device-time-zone";

/** Midnight on the calendar day of `date` in `timeZone` (not device local). */
const startOfCalendarDay = (date: TZDate, timeZone: string): TZDate =>
  new TZDate(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0,
    timeZone,
  );

/** Calendar day bounds [start, end) in the same timezone as `buildRelativeDateRange`. */
const getDayBoundsForOffset = (
  offset: number,
  params: BuildRelativeParams,
): { dayStart: TZDate; dayEnd: TZDate } | undefined => {
  const timeZone = params.timeZone ?? getDeviceTimeZone();
  const range = buildRelativeDateRange({ ...params, timeZone });
  const item = range.find((r) => r.offset === offset);
  if (!item) {
    return undefined;
  }

  const dayStart = startOfCalendarDay(item.date, timeZone);
  const dayEnd = startOfCalendarDay(addDays(dayStart, 1), timeZone);

  return { dayStart, dayEnd };
};

export default getDayBoundsForOffset;
